import {useEffect, useState} from "react";
import {useRouter} from "next/router";
import {authenticatedFetchAPI} from "@/pages/api/clearwattApi";
import ModelCardSkeletonComponent from "@/components/ui/skeletons/ModelCardSkeletonComponent";
import styles from "@/components/directory/EVsModelContainer.module.css";
import CarCardComponent from "@/components/ui/cards/CarCardComponent";
import ModelCardComponent from "@/components/ui/cards/ModelCardComponent";

export default function EVsModelContainer({make, shouldFetch}) {
  const [loading, setLoading] = useState(true);
  const [models, setModels] = useState([]);
  const [error, setError] = useState(null);
  const [perPage, setPerPage] = useState(10);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);

  const router = useRouter();

  /*useEffect(() => {
    if (!shouldFetch || !router.isReady) return;
    const newPage = router.query.page ? parseInt(router.query.page, 10) : 1;
    const newItemsPerPage = router.query.per_page
      ? parseInt(router.query.per_page, 10)
      : 10;

    const range = router.query.range || "";
    const sorting = router.query.sorting || "";
    const bodyStyle = router.query.body_style || "";
    const seats = router.query.seats || "";
    const price = router.query.price || "";
    setPage(newPage);
    setPerPage(newItemsPerPage);

    setLoading(true);

    let apiUrl = `/api/models?page=${newPage}&per_page=${newItemsPerPage}&range=${range}&sorting=${sorting}&body_style=${bodyStyle}&seats=${seats}&price=${price}`;
    if (make) {
      apiUrl += `&make=${make}`;
    }

    authenticatedFetchAPI(apiUrl)
      .then((data) => {

        if (data.data) {
          // Preprocess data to handle NaN average_range values
          const processedData = data.data.map(item => {
            if (!Number.isFinite(item.average_range)) {
              item.average_range = "Unknown";
            }
            return item;
          });

          setModels(processedData);
          setTotal(data.total);
          setPerPage(data.per_page);
          setPage(data.page);
        } else {
          setModels([]);
          setTotal(0);
          setPerPage(0);
          setPage(1);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error
        );
        setError(error);
        setLoading(false);
      });
  }, [make, router.query, router.isReady, shouldFetch]);*/


  useEffect(() => {
    if (!shouldFetch || !router.isReady) return;

    const newPage = router.query.page ? parseInt(router.query.page, 10) : 1;
    const newItemsPerPage = router.query.per_page
      ? parseInt(router.query.per_page, 10)
      : 10;

    const range = router.query.range || "";
    const sorting = router.query.sorting || "";
    const bodyStyle = router.query.body_style || "";
    const seats = router.query.seats || "";
    const price = router.query.price || "";

    setPage(newPage);
    setPerPage(newItemsPerPage);

    setLoading(true);

    let rangeGte, rangeLte;
    if (range) {
      [rangeGte, rangeLte] = range.split('-').map(Number);
    }

    const fetchData = async () => {
      let apiUrl = `${process.env.NEXT_PUBLIC_CLEARWATT_BASE_API}/vehicles/models_group/?page=${newPage}&page_size=${newItemsPerPage}`;
      if (make) {
        apiUrl += `&make__name=${make}`;
      }
      if (rangeGte !== undefined && rangeLte !== undefined) {
        apiUrl += `&range__gte=${rangeGte}&range__lte=${rangeLte}`;
      }
      if (sorting) apiUrl += `&order_by=${sorting}`;
      if (bodyStyle) apiUrl += `&body_style=${bodyStyle}`;
      if (seats) apiUrl += `&seats=${seats}`;
      if (price) apiUrl += `&price=${price}`;

      try {
        const response = await fetch(apiUrl);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();

        if (data.results) {
          // Preprocess data to handle NaN average_range values
          const processedData = data.results.map(item => {
            if (!Number.isFinite(item.average_range)) {
              item.average_range = "Unknown";
            }
            return item;
          });

          setModels(processedData);
          setTotal(data.count);
          setPerPage(data.per_page);
          setPage(data.current_page);
        } else {
          setModels([]);
          setTotal(0);
          setPerPage(0);
          setPage(1);
        }
      } catch (error) {
        console.error("There has been a problem with your fetch operation:", error);
        setError(error);  // Assuming setError is defined somewhere
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [make, router.query, router.isReady, shouldFetch]);

  if (loading) {

    return (
      <div className={styles.evsContainer}>
        {
          Array.from({length: 10}).map((_, index) => (
            <ModelCardSkeletonComponent key={index}/>
          ))
        }
      </div>
    );

  }

  if (error) {
    //return <ErrorMessage message={error.message} />; // Or your custom error component
    return (<div className={styles.noResults}><span className={styles.iconResults}>⚠️</span> Error...</div>);
  }

  if (models.length === 0) {
    return (<div className={styles.noResults}><span className={styles.iconResults}>🪫</span> No models found...</div>);
  }

  return (
    <div className={styles.evsContainer}>
      {models.map((model, index) => (
        <ModelCardComponent key={index} evModel={model} range={router.query.range} perPage={router.query.per_page}
                            sorting={router.query.sorting} bodyStyle={router.query.body_style}
                            price={router.query.price}/>
      ))}
    </div>
  );
}
